import React from "react";
import { Button, Col, Form, Row, Table } from "react-bootstrap";
import "../Style/VehicleAdvance.css";

const VehicleAdvanceForm = ({
  setDate,
  date,
  rows,
  handleChange,
  // handleAddRows,
  handleSave,
  filteredVehicle,
  handleVehicleChange,
  handleVehicleSelect,
  handleKeyDown,
}) => {
  return (
    <>
      <Form onSubmit={handleSave}>
        <Row>
          <Col md={4}>
            <Form.Group className="mb-3">
              <Form.Label>Date</Form.Label>
              <Form.Control
                type="date"
                value={date}
                name="date"
                onChange={(e) => setDate(e.target.value)}
              />
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <div className="excel-table-container">
              <Table bordered hover responsive className="excel-table">
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Vehicle</th>
                    <th>Amount</th>
                    <th>S.No</th>
                    <th>Vehicle</th>
                    <th>Amount</th>
                  </tr>
                </thead>
                <tbody>
                  {Array.from({ length: 35 }).map((_, i) => {
                    const leftIndex = i;
                    const rightIndex = i + 35;

                    const leftRow = rows[leftIndex];
                    const rightRow = rows[rightIndex];
                    return (
                      <tr key={i}>
                        <td>{leftIndex + 1}</td>
                        <td style={{ position: "relative" }}>
                          <Form.Control
                            id={`vehicle-${leftIndex}`}
                            type="text"
                            value={leftRow.vehicle_number || ""}
                            onChange={(e) => handleVehicleChange(leftIndex, e)}
                            onKeyDown={(e) => handleKeyDown(leftIndex, e)}
                            onFocus={() => {
                              if (leftRow.filteredVehicle?.length > 0) {
                                const updated = [...rows];
                                updated[leftIndex].showVehicleList = true;
                              }
                            }}
                            autoComplete="off"
                            className="excel-input"
                          />

                          {leftRow.showVehicleList &&
                            leftRow.filteredVehicle &&
                            leftRow.filteredVehicle.length > 0 && (
                              <div
                                style={{
                                  position: "absolute",
                                  background: "#fff",
                                  zIndex: 10,
                                  width: "100%",
                                  border: "1px solid #ccc",
                                  borderRadius: "4px",
                                  maxHeight: "150px",
                                  overflowY: "auto",
                                }}
                              >
                                {leftRow.filteredVehicle.map(
                                  (vehicle, vindex) => (
                                    <div
                                      key={vehicle.id}
                                      onMouseDown={(e) => e.preventDefault()}
                                      onClick={() =>
                                        handleVehicleSelect(leftIndex, vehicle)
                                      }
                                      style={{
                                        padding: "6px 10px",
                                        cursor: "pointer",
                                        borderBottom: "1px solid #eee",
                                        backgroundColor:
                                          vindex ===
                                          leftRow.highlightedVehicleIndex
                                            ? "#007bff22"
                                            : "white",
                                      }}
                                    >
                                      {vehicle.vehicle_number}
                                    </div>
                                  ),
                                )}
                              </div>
                            )}
                        </td>
                        <td>
                          <Form.Control
                            id={`amount-${leftIndex}`}
                            type="number"
                            name="amount"
                            value={leftRow.amount}
                            onChange={(e) =>
                              handleChange(leftIndex, "amount", e.target.value)
                            }
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                e.preventDefault();
                                const nextIndex = leftIndex + 1;
                                const nextInput = document.getElementById(
                                  `vehicle-${nextIndex}`,
                                );
                                if (nextInput) nextInput.focus();
                              }
                            }}
                            className="excel-input"
                          />
                        </td>
                        <td>{rightIndex + 1}</td>
                        <td style={{ position: "relative" }}>
                          <Form.Control
                            id={`vehicle-${rightIndex}`}
                            type="text"
                            value={rightRow.vehicle_number || ""}
                            onChange={(e) => handleVehicleChange(rightIndex, e)}
                            onKeyDown={(e) => handleKeyDown(rightIndex, e)}
                            onFocus={() => {
                              if (rightRow.filteredVehicle?.length > 0) {
                                const updated = [...rows];
                                updated[rightIndex].showVehicleList = true;
                              }
                            }}
                            autoComplete="off"
                            className="excel-input"
                          />

                          {rightRow.showVehicleList &&
                            rightRow.filteredVehicle &&
                            rightRow.filteredVehicle.length > 0 && (
                              <div
                                style={{
                                  position: "absolute",
                                  background: "#fff",
                                  zIndex: 10,
                                  width: "100%",
                                  border: "1px solid #ccc",
                                  borderRadius: "4px",
                                  maxHeight: "150px",
                                  overflowY: "auto",
                                }}
                              >
                                {rightRow.filteredVehicle.map(
                                  (vehicle, vindex) => (
                                    <div
                                      key={vehicle.id}
                                      onMouseDown={(e) => e.preventDefault()}
                                      onClick={() =>
                                        handleVehicleSelect(rightIndex, vehicle)
                                      }
                                      style={{
                                        padding: "6px 10px",
                                        cursor: "pointer",
                                        borderBottom: "1px solid #eee",
                                        backgroundColor:
                                          vindex ===
                                          rightRow.highlightedVehicleIndex
                                            ? "#007bff22"
                                            : "white",
                                      }}
                                    >
                                      {vehicle.vehicle_number}
                                    </div>
                                  ),
                                )}
                              </div>
                            )}
                        </td>
                        <td>
                          <Form.Control
                            id={`amount-${rightIndex}`}
                            type="number"
                            name="amount"
                            value={rightRow.amount}
                            onChange={(e) =>
                              handleChange(rightIndex, "amount", e.target.value)
                            }
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                e.preventDefault();
                                if (rightIndex === 69) {
                                  document.getElementById("saveBtn").click();
                                  return;
                                }

                                const nextIndex = rightIndex + 1;
                                const nextInput = document.getElementById(
                                  `vehicle-${nextIndex}`,
                                );
                                if (nextInput) nextInput.focus();
                              }
                            }}
                            className="excel-input"
                          />
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </div>
          </Col>
        </Row>
        <div className="d-flex justify-content-end mt-3">
          {/* <Button variant="success" onClick={handleAddRows}>
            Add Rows
          </Button> */}
          <Button id="saveBtn" variant="primary" type="submit">
            Save
          </Button>
        </div>
      </Form>
    </>
  );
};

export default VehicleAdvanceForm;
